// src/pages/SignupAcademy.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/SignupAcademy.css";
import axios from "axios";

const days = [
  { id: 1, name: "Mandag" },
  { id: 2, name: "Tirsdag" },
  { id: 3, name: "Onsdag" },
  { id: 4, name: "Torsdag" },
  { id: 5, name: "Fredag" },
  { id: 6, name: "Lørdag" },
  { id: 7, name: "Søndag" },
];

const ProfileAcademy = () => {
  const location = useLocation();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    age: "",
    parent_name: "",
    parent_email: "",
    parent_phone: "",
    ingame_name: "",

    game_id: "",
    game_name: "",
    training_time: "",
    day_id: "",
    day_name: "",
    level: ""
  });

  const [discordUser, setDiscordUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [personalId, setPersonalId] = useState("");

  // =========================
  // LOAD FROM LOCATION (før login)
  // =========================
  useEffect(() => {
    if (location.state) {
      setForm(prev => ({
        ...prev,
        ...location.state
      }));
    }
  }, []);

  // =========================
  // LOAD LOCALSTORAGE (efter login)
  // =========================
useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("academy_selection") || "{}");

  const combined = {
    game_id: saved.game_id || location.state?.game_id || "",
    game_name: saved.game_name || location.state?.game || "",
    training_time: saved.training_time || location.state?.training_time || "",
    day_id: saved.day_id || location.state?.day || "",
    day_name: saved.day_name || "",
    level: saved.level || location.state?.level || ""
  };

  setForm(prev => ({
    ...prev,
    ...combined
  }));
}, []);

  // =========================
  // SAVE ONLY GAME DATA
  // =========================
  useEffect(() => {
    const selectionOnly = {
      game_id: form.game_id,
      game_name: form.game_name,
      training_time: form.training_time,
      day_id: form.day_id,
      day_name: form.day_name,
      level: form.level
    };

    localStorage.setItem("academy_selection", JSON.stringify(selectionOnly));
  }, [
    form.game_id,
    form.game_name,
    form.training_time,
    form.day_id,
    form.day_name,
    form.level
  ]);

  // =========================
  // DAY MAPPING
  // =========================
  useEffect(() => {
    if (form.day_id) {
      const dayObj = days.find(d => d.id === Number(form.day_id));
      if (dayObj) {
        setForm(prev => ({ ...prev, day_name: dayObj.name }));
      }
    }
  }, [form.day_id]);

  // =========================
  // DISCORD CHECK
  // =========================
  useEffect(() => {
    axios
      .get("https://linxlegacyacademy.dk/auth/user", {
        withCredentials: true
      })
      .then(res => {
        if (res.data.status === "logged_in") {
          setDiscordUser(res.data.user);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  // =========================
  // INPUT CHANGE
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setPersonalId("");

    try {
      const payload = {
        ...form,
        discord_username: discordUser?.username || null,
        discord_id: discordUser?.discord_id || null
      };

      const res = await axios.post(
        "https://linxlegacyacademy.dk/api/academy/signup",
        payload,
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setPersonalId(res.data.personal_id);
        setMessage(`Tilmelding gennemført! Dit ID: ${res.data.personal_id} 🎉`);

        localStorage.removeItem("academy_selection");
      } else {
        setMessage(res.data.error || "Fejl");
      }
    } catch (err) {
      setMessage(err.response?.data?.error || "Fejl ved signup");
    }
  };

  if (loading) return <p>Loader...</p>;

  const under18 = parseInt(form.age || 0) < 18;

  // =========================
  // UI (DIN TEKST BEVARET)
  // =========================
  return (
    <div className="signup-page">

      <h1>Bliv bedre til dit spil 🎮</h1>

      <section className="benefits">
        <h2>Hvad får du som medlem?</h2>
        <ul>
          <li>🎮 Ugentlig træning med coach</li>
          <li>📈 Fokus på skill og teamwork</li>
          <li>🏆 Turneringer og events</li>
          <li>💬 Aktivt Discord community</li>
          <li>🔥 Seriøst men sjovt miljø</li>
        </ul>
      </section>

      <section className="instructions">
        <h2>Sådan fungerer det</h2>
        <ol>
          <li>Vælg spil og tid</li>
          <li>Kom til gratis prøvetræning</li>
          <li>Aktiver medlemskab</li>
        </ol>

        <p><strong>Pris:</strong> 2000 kr / halvår</p>
        <p>Første træning er gratis 🎯</p>
      </section>

      <section className="practical">
        <h2>Praktisk info</h2>
        <p><strong>Opstart:</strong> Løbende optag</p>
        <p><strong>Platform:</strong> Discord</p>
        <p><strong>Udstyr:</strong> PC + headset</p>
        <p><strong>Varighed:</strong> 1-2 timer</p>
        <p><strong>Hold:</strong> 5-10 spillere</p>
      </section>

      <section className="game-info">
        <h3>Dit valgte hold</h3>

        <ul>
          <li><strong>Spil:</strong> {form.game_name || "Ikke valgt"}</li>
          <li><strong>Dag:</strong> {form.day_name || "Ikke valgt"}</li>
          <li><strong>Tid:</strong> {form.training_time || "Ikke valgt"}</li>
          <li><strong>Level:</strong> {form.level || "Ikke valgt"}</li>
        </ul>

        <a href="/Gametime" className="btn primary">
          Vælg holdtid
        </a>
      </section>

      <div className="connect-section">
        <button
          onClick={() =>
            window.location.href = "/auth/discord/login?type=academy"
          }
          className="btn primary"
        >
          {discordUser ? "Discord forbundet" : "Login med Discord"}
        </button>
      </div>

      {!discordUser && (
        <p>Du skal logge ind med Discord for at fortsætte</p>
      )}

      <form onSubmit={handleSubmit} className="signup-form">

        <h2>Udfyld dine oplysninger</h2>

        <label>Navn</label>
        <input name="name" value={form.name} onChange={handleChange} required />

        <label>Email</label>
        <input name="email" value={form.email} onChange={handleChange} required />

        <label>Telefon</label>
        <input name="phone" value={form.phone} onChange={handleChange} required />

        <label>Alder</label>
        <input name="age" type="number" value={form.age} onChange={handleChange} required />

        {under18 && (
          <>
            <label>Forældre navn</label>
            <input name="parent_name" value={form.parent_name} onChange={handleChange} />

            <label>Forældre email</label>
            <input name="parent_email" value={form.parent_email} onChange={handleChange} />

            <label>Forældre telefon</label>
            <input name="parent_phone" value={form.parent_phone} onChange={handleChange} />
          </>
        )}

        <label>Ingame navn</label>
        <input name="ingame_name" value={form.ingame_name} onChange={handleChange} />

        <button type="submit" disabled={!discordUser}>
          Aktiver medlemskab
        </button>

        {personalId && <p>Dit ID: {personalId}</p>}

      </form>

      {message && <p>{message}</p>}

    </div>
  );
};

export default ProfileAcademy;